import React, { Component } from 'react';
import { Modal, message, DatePicker } from 'antd';
import moment from 'moment';

const dateFormat = 'YYYY-MM-DD';

class AssignEmployee extends Component {
    state = {
        record: {},
        visible: false,
    }

    show = (params) => {
        this.setState({
            visible: true,
            record: {...params},
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    confirm = () => {
        const { record, record: { entryDate } } = this.state;
        if (!entryDate) {
            message.warning('请选择人员到位时间');
            return;
        }
        this.setState({
            visible: false,
        }, () => {
            this.props.process(record);
        })
    }

    handeleDateChange = (date, dateString) => {
        const { record } = this.state;
        record.entryDate = dateString;
        this.setState({ record });
    }

    render() {
        const { visible, record: { employeeName, employeeCode, entryDate, userName } } = this.state;
        return (
            <Modal
                title="分派人员"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                width="400px"
            >
                <div className="modal-content" style={{ padding: 0 }}>
                    <ul className="modal-list">
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 100, paddingRight: 10}}>分派人员:</div>
                            <div className="item-right">{userName}({employeeCode})</div>
                        </li>
                        <li className="modal-item" style={{paddingBottom: 20}}>
                            <div className="item-left" style={{width: 100, paddingRight: 10}}>
                                <span style={{ color: 'red' }}>*</span>
                                人员到位时间:
                            </div>
                            <div className="item-right">
                                <DatePicker
                                    style={{width:160}}
                                    format={dateFormat}
                                    placeholder="请选择"
                                    value={entryDate ? moment(entryDate) : null }
                                    onChange={this.handeleDateChange}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}

export default AssignEmployee;



// WEBPACK FOOTER //
// ./src/components/user/transfer/components/AssignEmployee.js